import { PageHeader, RegionCargando, Skeleton, Stack, TablaSkeleton } from "@/components/ui";
import { PAGE_SIZE } from "@/lib/hooks/use-server-pagination";
import { COLUMNAS_FACTURAS, MIN_WIDTH_FACTURAS } from "./FacturasTable";

/** Título y subtítulo de «Mis facturas» · compartidos por la página y su skeleton. */
export const ENCABEZADO_MIS_FACTURAS = {
  titulo: "Mis facturas",
  descripcion: "CFDIs validados en tus solicitudes de pago · cada carga genera un acuse de validación descargable en PDF.",
} as const;

/**
 * «Mis facturas» en su primera carga · MISMA forma que `MisFacturasPage`
 * (contenedor, encabezado real con sus 2 acciones, toolbar Filtros/paginación y
 * la tabla ancha con sus 17 columnas reales). Es el `pendingComponent` de la
 * ruta `/facturas` Y la rama `isPending` de la página. Sin variante de tarjetas:
 * la página real muestra la misma tabla (con scroll horizontal) también en móvil.
 */
export function MisFacturasSkeleton() {
  return (
    <RegionCargando etiqueta="Cargando facturas…" className="w-full px-4 py-6 md:px-6">
      <PageHeader
        title={ENCABEZADO_MIS_FACTURAS.titulo}
        description={ENCABEZADO_MIS_FACTURAS.descripcion}
        actions={
          // Exportar a Excel · refrescar.
          <div className="flex items-center gap-2" aria-hidden="true">
            <Skeleton height={36} width={36} />
            <Skeleton height={36} width={36} />
          </div>
        }
      />
      <Stack gap="md">
        <div aria-hidden="true">
          <TablaSkeleton columnas={COLUMNAS_FACTURAS} minWidth={MIN_WIDTH_FACTURAS} filas={PAGE_SIZE} conToolbar />
        </div>
      </Stack>
    </RegionCargando>
  );
}
